export default __webpack_public_path__ + "static/media/loading.128b4cda.gif";